import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/Style.css';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { LanguageContext } from "../contexts/LanguageContext";
import Cookies from 'js-cookie';
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
//import { useCaseInfo } from "../contexts/CaseInfoContext";

const Footer = ({ caseInfo }) => {
    const navigate = useNavigate();
    const { pageContent } = useContext(LanguageContext);
    const [genericContent, setGenericContent] = useState([]);
    const [logoSrc, setLogoSrc] = useState('');
    const [logotitle, setLogoTitle] = useState(''); //st48236 - 508 compliance
    const [privacyLink, setPrivacyLink] = useState('');
    const [stateFaqCheck, setStateFaqCheck] = useState(false);
    const [stateFaqList, setStateFaqList] = useState([]);
    //const { caseInfo } = useCaseInfo();

    const Payload = GetPayLoad('PayLoad');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region ?? Cookies.get("region") ?? "",
        "X-Hps-Carrier": Payload?.owning_carrier ?? Cookies.get("owningCarrier") ?? ""
    };

    let owningCarrier = Cookies.get('owningCarrier') || '';
    const stateCode = sessionStorage.getItem('stateCode') || '';

    const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier");
    const connectiCareCarrier = Cookies.get("connectiCareCarrier");

    useEffect(() => {
        
        const targetRuleValueUrl = process.env.REACT_APP_API_GET_PROGRAM_RULE_VALUE_ENDPOINT;
        getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'PRIVACY_LINK', carrierCode: isConnectiCareCarrier === 'true' ? connectiCareCarrier : Payload?.owning_carrier ?? Cookies.get("owningCarrier") }, headers)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const result = response.data.data;
                    setPrivacyLink(result);
                }
            })
            .catch(error => {
                console.log("Get rule value API Failure");
            });
    }, []);

    // Check Cigna Faq Link, only cookie exists
    
    const [cignaFaqLink, setCignaFaqLink] = useState('');
    
    //st48236 - using for FAQ url checking
      useEffect(() => {
        const carrier = Cookies.get("owningCarrier");
        if (!carrier) {
            return;
        }
        
        const isUsaaFaq = caseInfo?.isUSAAFaq === true || Cookies.get('isUsaaFaq') === 'true';
        const isNonUsaaFaq = caseInfo?.isNonUSAAFaq === true || Cookies.get('isNonUsaaFaq') === 'true';
        
        const targetRuleValueUrl = process.env.REACT_APP_API_GET_PROGRAM_RULE_VALUE_ENDPOINT;
        getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_STATE_BASED_CHECK', carrierCode: carrier }, headers)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const result = response.data.data;
                    setStateFaqCheck(result);
                }
            })
            .catch(error => {
                console.log("Get FQA state check rule value API Failure");
            });
        getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_STATE_LIST', carrierCode: carrier }, headers)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const result = response.data.data;
                    setStateFaqList(result);
                }
            })
            .catch(error => {
                console.log("Get FAQ state list rule value API Failure");
            });
            
        // This is only for Cigna FAQ Link
        if(isUsaaFaq){
            getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_LINK_USAA', carrierCode: carrier }, headers)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const result = response.data.data;
                    setCignaFaqLink(result);
                }
            })
            .catch(error => {
                console.log("Get FAQ state list rule value API Failure");
            });
        }else if(isNonUsaaFaq){
            getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_LINK', carrierCode: carrier }, headers)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const result = response.data.data;
                    setCignaFaqLink(result);
                }
            })
            .catch(error => {
                console.log("Get FAQ non USAA link rule value API Failure");
            });
        }
      }, [ caseInfo?.isUSAAFaq, caseInfo?.isNonUSAAFaq]);

    useEffect(() => {
        switchTheme();
        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
        //st48236 - 508 compliance
        const logo_title_txt = "logo_title_" + owningCarrier;
        if (genericContent?.[logo_title_txt] !== undefined) {
            setLogoTitle(genericContent?.[logo_title_txt]);
        } else {
            if (owningCarrier === 'CG') {
                setLogoTitle("Cigna Member Portal");
            }
            if (owningCarrier === 'M1') {
                setLogoTitle("MHC Member Portal");
            }
            if (owningCarrier === 'Q5') {
                setLogoTitle("BCBSAZ Member Portal");
            }
            if (owningCarrier === 'SY') {
                setLogoTitle("Sentara Member Portal");
            }
            if (owningCarrier === 'XC') {
                setLogoTitle("Christus Member Portal");
            }
            if (owningCarrier === 'C4') {
                setLogoTitle("Molina Member Portal");
            }
        }
        //st48236 - 508 compliance
    }, [pageContent]);
    
    const switchTheme = async () => {
        let carrier = Cookies.get("owningCarrier");
        if(isConnectiCareCarrier === 'true' && connectiCareCarrier !== null && connectiCareCarrier !== undefined){
            carrier = connectiCareCarrier;
        }

        import('../assets/images/carriers-logo/' + carrier + '-sml.svg').then((image) => {
            setLogoSrc(image.default);
        });

        await import('../assets/css/' + carrier + '.css');
    };

    const handleLink = (e) => {
         e.preventDefault();
        
         window.open('https://www.connecticare.com/contact', '_blank', 'noopener,noreferrer');
    };

    const handleClick = (e) => {
         e.preventDefault();
        
         window.open('https://www.connecticare.com/resources/member-faq', '_blank', 'noopener,noreferrer');
    };

    // Set FAQ URL based on carrier and state, with special handling for ConnectiCare carriers to point to their FAQ page instead of state-specific FAQs
    const [faqUrl, setFaqUrl] = useState('');
    useEffect(() => {    
        if(stateFaqCheck == 'true'){
            const state = Payload?.state || stateCode;
            const stateArray = stateFaqList && typeof stateFaqList === 'string' ? stateFaqList.split(',').map(state => state.trim().toLowerCase()) : [];
            let stateFaqUrl = '';
            if(stateArray.includes(state?.toLowerCase())){
                const faqStr = "faq_link_"+state?.toLowerCase()
                stateFaqUrl = genericContent?.[faqStr]??'';
            }
            setFaqUrl(stateFaqUrl);
        }else if(cignaFaqLink && cignaFaqLink !== ''){
            const faqUrl = process.env.REACT_APP_API_BASE_URL + cignaFaqLink;
            //console.log("Cigna FAQ Link: ", faqUrl);
            setFaqUrl(faqUrl);
        }else{
            const faqUrl = genericContent?.faq_link??'';
            setFaqUrl(faqUrl);
        }
    
    }, [Payload, stateFaqCheck, stateFaqList, genericContent]);

    return (
        <>
            <footer className="footer sidebar-footer mt-auto">
                <div className="footer-body">
                    {owningCarrier !== 'Q5' && (
                        <div className="right-panel overviewnavigate footer-right-panel">
                            <img
                                src={logoSrc}
                                width="mw-100"
                                alt={logotitle || "Member Portal"} // 508 compliance
                                role="button"
                                tabIndex={0}
                                onClick={() => navigate('/overview')}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        navigate('/overview');
                                    }
                                }}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    )}

                    <ul className={`left-panel list-inline mb-0 p-0 mt-2 footer-left-panel${owningCarrier === 'Q5' ? ' footer-left-panel-full' : ''}`}>
                        <li className="list-inline-item">
                            <NavLink to="/limitedproficiency" activeClassName="active">
                                {genericContent?.footer_limited_eng_prof_menu}
                            </NavLink>
                        </li>
                        <li className="list-inline-item">
                            <NavLink to="/nondiscrimination" activeClassName="active">{genericContent?.footer_non_disc_menu}</NavLink>
                        </li>
                        <li className="list-inline-item">
                            {isConnectiCareCarrier === 'true' ? (
                                <NavLink to="/contactus" onClick={handleLink} onKeyDown={handleLink} activeClassName="active">{genericContent?.layout_contact_us_page_title}</NavLink>
                            ) : (
                                <NavLink to="/contactus" activeClassName="active">{genericContent?.layout_contact_us_page_title}</NavLink>
                            )}
                        </li>
                        <li className="list-inline-item">
                            
                            {faqUrl ? (
                                <a id='faq-link' onClick={() => window.open(faqUrl, '_blank', 'noopener,noreferrer')} 
                                onKeyDown={() => window.open(faqUrl, '_blank', 'noopener,noreferrer')}
                                tabIndex={0}
                                activeClassName="active">{genericContent?.layout_faq_page_title}</a>
                            ) : (
                                <NavLink to="/faq" activeClassName="active">{genericContent?.layout_faq_page_title}</NavLink>
                            )}
                            
                        </li>
                        <li className="list-inline-item">
                            <NavLink to="/glossary" activeClassName="active">{genericContent?.footer_glossary_menu}</NavLink>
                        </li>
                        <li className="list-inline-item">
                            {privacyLink !== '' && (
                            <NavLink to="/privacy" 
                            onClick={(e) => {
                                e.preventDefault();
                                window.open(privacyLink, '_blank', 'noopener,noreferrer'); 
                            }}
                            activeClassName="active">{genericContent?.footer_privacy_menu}</NavLink>
                            )}
                        </li>
                    </ul>
                </div>
            </footer>
        </>
    )
}

export default Footer;